export default class GroupRepresentation {
  constructor(id, name, path) {
    this.id = id;
    this.name = name;
    this.path = path;
  }

  static build({ id, name, path }) {
    return new GroupRepresentation(id, name, path);
  }

  static parse(value) {
    return value ? GroupRepresentation.build({
      id: value.id,
      name: value.name,
      path: value.path
    }) : null;
  }

  toJSON() {
    return {
      id: this.id !== undefined && this.id !== '' ? this.id : null,
      name: this.name !== undefined && this.name !== '' ? this.name : null,
      path: this.path !== undefined && this.path !== '' ? this.path : null
    };
  }
}
